import * as defaultImport from "@splunk/themes";
export * from "@splunk/themes";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
